import React, {
  useState,
  useContext,
  type Dispatch,
  type SetStateAction,
  type ReactNode,
  useMemo,
} from "react";

import { type OauthUserType, type FundraiserType } from "@fwa/src/types";

export type FundraiserContextStateType = {
  fundraiser: FundraiserType | null | undefined;
  oauthUser: OauthUserType | null | undefined;
  // we don't have to record loggedInStatus
  // but it might be useful to know what is going on for potential loading states
  loggedInStatus: "unknown" | "loggedOut" | "loggedIn";
};

const defaultState: FundraiserContextStateType = {
  fundraiser: undefined,
  oauthUser: undefined,
  loggedInStatus: "unknown",
};

export type FundraiserContextProviderType = [
  FundraiserContextStateType,
  Dispatch<SetStateAction<FundraiserContextStateType>>,
];

export const FundraiserContext =
  React.createContext<FundraiserContextProviderType>([
    { ...defaultState },
    () => {
      // placeholder for init not actually used
    },
  ]);

export const useFundraiserContext = () => useContext(FundraiserContext);

export const FundraiserContextProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [state, setState] = useState({
    ...defaultState,
  });

  const value = useMemo(
    () => [state, setState],
    [state],
  ) as FundraiserContextProviderType;

  return (
    <FundraiserContext.Provider value={value}>
      {children}
    </FundraiserContext.Provider>
  );
};
